const Dashboard = () => { 
    return (
        <h1 className="text-4xl text-center">Bienvenido a Databridge</h1>
    )
}

export default Dashboard;